.chart {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    background-color: #fff;
    overflow-y: hidden;

    display: flex;
    padding: var(--spacing-3xl, 24px);
    gap: var(--spacing-3xl, 24px);

    border-radius: var(--radius-xl, 12px);
    border: 1px solid var(--colors-border-border-secondary, #EAECF0);
}

.chartHeadingGroup {
    flex: 1 0 0;
    cursor: grab;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;

    &.hideDrag {
        cursor: default;
    }
}

.chartHeading {
    color: var(--colors-text-text-primary-900, #101828);
    font-feature-settings: 'clig' off, 'liga' off;
    font-family: "Open Sans";
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px;

    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
}

.chartSubheading {
    overflow: hidden;
    color: var(--colors-text-text-tertiary-600, #475467);
    font-feature-settings: 'clig' off, 'liga' off;
    text-overflow: ellipsis;
    font-family: "Open Sans";
    font-size: 11px;
    font-style: normal;
    font-weight: 400;
    line-height: 14px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.filterBlock {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    width: 100%;
    gap: 12px;
}

.filterButtonGroup {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 16px;
    width: 100%;
}

.buttonBase {
    cursor: pointer;
    display: flex;
    min-height: 40px;
    padding: var(--spacing-md, 8px) var(--spacing-xl, 16px);
    background-color: rgba(255, 255, 255, 1);
    justify-content: center;
    align-items: center;
    gap: var(--spacing-md, 8px);
    border: none;

    &:hover {
        background-color: rgba(241, 244, 255, 1);
    }

    &.filterButtonActive {
        background-color: rgba(241, 244, 255, 1);
        color: rgba(65, 73, 247, 1);
        cursor: default;
    }
}

.combineGroup {
    display: flex;
    flex-direction: column;
    width: 100%;
}

.upGroup {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    position: relative;
    gap: 12px;
}

.downGroup {
    position: relative;
}

.controlIcon {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
}

.rangeContainer {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 16px;
    width: 100%;
}

.chartContainer {
    box-sizing: border-box;
    z-index: 2;
    max-width: calc(100vw - 603px);
    min-width: 400px;

    &.cube {
        width: calc(50% - 10px);
        min-width: unset;
        max-width: unset;
    }
}

@media (max-width: 1080px) {
    .chartContainer.cube {
        width: 100%;
        min-width: unset;
        max-width: unset;
    }
}